"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DECORATE_ACTIONS = exports.CALL_API = exports.Schemas = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _normalizr = require("normalizr");

var normalizr = _interopRequireWildcard(_normalizr);

var _normalizers = require("./normalizers");

var normalizers = _interopRequireWildcard(_normalizers);

var _get_cookie = require("../helpers/get_cookie");

var _get_cookie2 = _interopRequireDefault(_get_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var csrfSafeMethod = function csrfSafeMethod(method) {
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
    );
};

function callApi(service, endpoint, schema) {
    var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "GET";
    var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var formData = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var done = arguments[6];
    var error = arguments[7];

    var requestBody = null,
        serviceRoot = void 0;

    switch (service) {
        case "api":
            serviceRoot = "/fort/modparty/api_proxy/";
            break;
        case "www":
            serviceRoot = "/";
            break;
        case "raw":
            serviceRoot = "";
            break;
    }

    var fullUrl = serviceRoot + endpoint;

    var xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    if (service !== "raw") {
        xhr.withCredentials = true;
    } else {
        xhr.withCredentials = false;
    }
    xhr.onload = function () {
        var response = void 0;
        if (service !== "raw") {
            try {
                response = JSON.parse(this.responseText);
            } catch (err) {
                console.warn(fullUrl, "JSON parse failed", err);
                return error({
                    code: this.status,
                    message: "Something went wrong."
                });
            }
        } else {
            response = this.responseText;
        }

        if (this.status >= 400 || response.errors) {
            if (!response.errors) {
                var messageForUser = response.form_errors || response.error;
                return error({ code: this.status, message: messageForUser });
            } else {
                return error({
                    code: response.errors.error.code,
                    message: response.errors.error.message
                });
            }
        }

        if (schema) {
            var normalizedResponse = Object.assign({}, schema.normalizer(response, schema.schema));
            done(normalizedResponse);
        } else {
            done(response);
        }
    };
    xhr.onerror = function () {
        return error({ code: this.status });
    };
    if (data) {
        if (method === "GET") console.warn("GET request includes JSON data. Check action creator.");
        requestBody = JSON.stringify(data);
        var csrfCookie = (0, _get_cookie2.default)(csrfCookieName);
        if (!csrfSafeMethod(method) && csrfCookie) {
            xhr.setRequestHeader("X-CSRFToken", csrfCookie);
        }
        xhr.setRequestHeader("Content-Type", "application/json");
    }

    if (formData) {
        if (method === "GET") console.warn("GET request includes form data. Check action creator.");
        requestBody = formData;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        if (!csrfSafeMethod(method)) {
            xhr.setRequestHeader("X-CSRFToken", (0, _get_cookie2.default)(csrfCookieName));
        }
    }
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

    xhr.send(requestBody);
}

var getResponseErrorMessage = function getResponseErrorMessage(error) {
    // Take an error object, and return a string to display in error tracking service
    if (typeof error === "string") return error;
    if (error.message) return error.message;
    if (error.field_errors) {
        if (error.field_errors.__all__) return error.field_errors.__all__[0].code;
        return "field_errors";
    }
};

// We use this Normalizr schemas to transform API responses from a nested form
// to a flat form where repos and users are placed in `entities`, and nested
// JSON objects are replaced with their IDs. This is very convenient for
// consumption by reducers, because we can easily build a normalized tree
// and keep it updated as we fetch more data.

// Read more about Normalizr: https://github.com/paularmstrong/normalizr

var Creator = new normalizr.Schema("creator", { idAttribute: "id" });
var User = new normalizr.Schema("user", { idAttribute: "id" });
var Collections = new normalizr.Schema("collections", { idAttribute: "id" });
var Icons = new normalizr.Schema("icons", { idAttribute: "id" });
var Search = new normalizr.Schema("search", { idAttribute: "id" });
var Upload = new normalizr.Schema("batch", { idAttribute: "id" });

var Schemas = exports.Schemas = {
    ICONS: { schema: Icons, normalizer: normalizers.icons },
    COLLECTIONS: { schema: Collections, normalizer: normalizers.collections },
    UPLOAD: { schema: Upload, normalizer: normalizers.upload },
    CREATOR: { schema: Creator, normalizer: normalizers.creator },
    USER: { schema: User, normalizer: normalizers.user },
    SEARCH: { schema: Search, normalizer: normalizers.search }
};

// Action key that carries API call info interpreted by this Redux middleware.
var CALL_API = exports.CALL_API = Symbol("Call API");
// Action key that includes payload to merge into dispatched SUCCESS/FAIL actions
var DECORATE_ACTIONS = exports.DECORATE_ACTIONS = Symbol("Decorate Actions");

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.

exports.default = function (store) {
    return function (next) {
        return function (action) {
            var callAPI = action[CALL_API];

            if (typeof callAPI === "undefined") {
                return next(action);
            }

            var endpoint = callAPI.endpoint,
                notifyModal = false;
            var service = callAPI.service,
                schema = callAPI.schema,
                types = callAPI.types,
                data = callAPI.data,
                formData = callAPI.formData,
                method = callAPI.method;


            if (callAPI.notifyModal) notifyModal = true;

            if (typeof endpoint === "function") {
                endpoint = endpoint(store.getState());
            }

            if (typeof endpoint !== "string") {
                throw new Error("Specify a string endpoint URL.");
            }

            if (!Array.isArray(types) || types.length !== 3) {
                throw new Error("Expected an array of three action types.");
            }
            if (!types.every(function (type) {
                return typeof type === "string";
            })) {
                throw new Error("Expected action types to be strings.");
            }

            function actionWith(data) {
                var finalAction = Object.assign({}, action, data);
                delete finalAction[CALL_API];

                if (action[DECORATE_ACTIONS]) {
                    Object.assign(finalAction, action[DECORATE_ACTIONS]);
                    delete finalAction[DECORATE_ACTIONS];
                }

                return finalAction;
            }

            var _types = _slicedToArray(types, 3),
                requestType = _types[0],
                successType = _types[1],
                failureType = _types[2];

            next(actionWith({
                formData: callAPI.formData,
                type: requestType,
                notifyModal: notifyModal,
                page: callAPI.page,
                id: callAPI.id,
                contentType: callAPI.contentType
            }));

            return callApi(service, endpoint, schema, method, data, formData, function (response) {
                return next(actionWith({
                    type: successType,
                    response: response,
                    notifyModal: notifyModal,
                    page: callAPI.page,
                    id: callAPI.id,
                    apiResponse: true,
                    contentType: callAPI.contentType
                }));
            }, function (error) {
                return next(actionWith({
                    formData: callAPI.formData,
                    type: failureType,
                    id: callAPI.id,
                    notifyModal: notifyModal,
                    statusCode: error.code,
                    contentType: callAPI.contentType,
                    apiResponse: true,
                    error: error.message || "Sorry, an error occurred."
                }));
            });
        };
    };
};